var  loaders = require('../../../layout/components/loaders');

class GroupingTool extends go.Tool {
  constructor(diagram, equipmentRecord, submitCallback) {
    super();
    this.diagram = diagram;
    this.name = "GroupingTool";
    this.equipmentRecord = equipmentRecord;
    this.submitCallback = submitCallback;
  }

  canStart() {
    return this.isActive && this.isEnabled;
  }

  doActivate() {
    super.doActivate();
    this.isActive = true;
    this.diagram.defaultCursor = "crosshair";
  }

  doMouseDown() {
    if (!this.isActive) return;

    const startPoint = this.diagram.lastInput.documentPoint;
    // Create a new rectangle part each time mouse is pressed down
    const box = new go.Part({
      layerName: "Tool",
      selectable: false,
      location: startPoint,
    });

    const shape = new go.Shape({
      figure: "Rectangle",
      fill: "rgba(0,0,255,0.15)",  // semi-transparent blue
      stroke: "dodgerblue",
      strokeWidth: 2,
      width: 0,
      height: 0
    });
    box.add(shape);
    this.diagram.add(box);
    this.startTransaction("Draw Grouping");

    // Attach the new box to the tool instance for tracking during the current drawing operation
    this.currentBox = box;
  }

  doMouseMove() {
    if (!this.isActive || !this.currentBox) return;
  
    const currentPoint = this.diagram.lastInput.documentPoint;
    const start = this.currentBox.location;
  
    // Calculate width and height based on absolute distance in any direction
    const width = Math.abs(currentPoint.x - start.x);
    const height = Math.abs(currentPoint.y - start.y);
  
    // Determine the top-left corner of the rectangle based on drag direction
    const x = Math.min(currentPoint.x, start.x);
    const y = Math.min(currentPoint.y, start.y);
  
    // Adjust the initial location if dragging towards the top or left
    if (currentPoint.x < start.x) {
      this.currentBox.location = new go.Point(currentPoint.x, this.currentBox.location.y);
    }
    if (currentPoint.y < start.y) {
      this.currentBox.location = new go.Point(this.currentBox.location.x, currentPoint.y);
    }
  
    // Access the shape directly from the currentBox and update its properties
    const shape = this.currentBox.elements.first();
    if (shape) {
      // Update shape size
      shape.width = width;
      shape.height = height;
      shape.desiredSize = new go.Size(width, height);
    }
  
    // Update the position of the box to the new top-left corner
    this.currentBox.position = new go.Point(x, y);
  }
  

  doMouseUp() {
    if (this.isActive) {
      const shape = this.currentBox.elements.first();
      if (shape) {
        // Extract the shape's properties correctly
        const bounds = shape.actualBounds;  // Use actualBounds to get the correct dimensions and position
        // Create a data object for the square with corrected properties
        const squareData = {
          loc: `${this.currentBox.position.x || this.currentBox.position.S} ${this.currentBox.position.y || this.currentBox.position.P}`,
          width: bounds.width,
          height: bounds.height,
        };
    
        if (this.equipmentRecord.groups && Array.isArray(this.equipmentRecord.groups) && this.equipmentRecord.groups.length > 0) {
          squareData.id = this.equipmentRecord.groups.length + 1;
          this.equipmentRecord.groups.push(squareData);
        } else {
          squareData.id = 1;
          this.equipmentRecord.groups = [squareData];
        }

        let url = `/api/v1/customequipment/${this.equipmentRecord['@rid'].slice(1)}/groups`;
    
        // Start transaction before making the request
        this.startTransaction("Save Grouping");
        this.isActive = false;
        return loaders.requestWithLoader({
          loaders: 'main',
          url: url,
          method: "PUT",
          body: this.equipmentRecord.groups,
        })
        .then((response) => {
          this.stopTransaction();
          this.diagram.currentTool = this.diagram.defaultTool;
          this.stopTool();
        })
        .catch((error) => {
          console.error("Failed to save square data", error);
          // Roll back any changes if the save fails
          this.rollbackTransaction("Save Grouping");
        })
        .finally(() => {
          // Clear the current box reference to prepare for the next drawing
          this.currentBox = null;
          this.submitCallback();
        });
      } else {
        this.stopTransaction();
        this.isActive = false;
        this.diagram.currentTool = this.diagram.defaultTool;
        this.stopTool();
  
        // Clear the current box reference to prepare for the next drawing
        this.currentBox = null;
        this.submitCallback();
      }
    }
  }
}

module.exports = GroupingTool;
